import {
  getEnabledThresholds,
  getUniqueThresholdValues,
} from 'features/timeSeries'
import { useMemo } from 'react'
import {
  BaseSensorEntry,
  EnhancedSensorEntry,
  LocalThresholdOverrideType,
} from 'types'

interface UseTimeSeriesSensorsProps {
  sensorEntries: BaseSensorEntry[]
  selectedSensors: BaseSensorEntry[]
  localThresholdOverrides: LocalThresholdOverrideType
}

export const useTimeSeriesSensors = ({
  sensorEntries,
  selectedSensors,
  localThresholdOverrides,
}: UseTimeSeriesSensorsProps) => {
  const enhancedSensorEntries: EnhancedSensorEntry[] = useMemo(() => {
    return sensorEntries.map((sensor) => {
      const override = localThresholdOverrides[sensor.id]
      if (!override) return sensor

      return {
        ...sensor,
        data: {
          ...sensor.data,
          thresholds: override,
        },
      }
    })
  }, [sensorEntries, localThresholdOverrides])

  const selectedSensorEntries = useMemo(
    () =>
      enhancedSensorEntries.filter((sensor) =>
        selectedSensors.find(
          (selectedSensor) => selectedSensor.id === sensor.id
        )
      ),
    [enhancedSensorEntries, selectedSensors]
  )
  const enabledThresholds = useMemo(() => {
    return getEnabledThresholds(selectedSensorEntries)
  }, [selectedSensorEntries])

  const uniqueThresholds = useMemo(() => {
    return getUniqueThresholdValues(enabledThresholds)
  }, [enabledThresholds])

  return {
    enhancedSensorEntries,
    uniqueThresholds,
  }
}
